import Draggable from 'react-draggable'

import { AspectRatio, Box, Drawer } from '@mantine/core'
import useStyles from './index.styles'
import { useContext, useEffect, useMemo, useRef, useState } from 'react'
import { MANTINE_MODAL_TARGET } from 'interfaces/constants'
import { LeadgenWithBannerContext } from '../context'
import { Button } from '@hhgtech/hhg-components/mantine'
import { useCurrentUrl } from 'hooks/useCurrentUrl'
import { Close } from '@hhgtech/icons/core'
import dynamic from 'next/dynamic'
const LeadForm = dynamic(() => import('../form').then((res) => res.Form), {
  ssr: false,
})

type Props = {
  opened: boolean
  onClose?: () => void
}

export const DrawerModal = ({ opened }: Props) => {
  const { isModal, data, close } = useContext(LeadgenWithBannerContext)

  const { campaigns, banner, thankYouMessage, isSkippable } = data
  const currentUrl = useCurrentUrl()
  const ref = useRef<HTMLDivElement | null>(null)
  const defaultHeight = useMemo(() => 0.8 * window.innerHeight, [])
  const [modalHeight, setModalHeight] = useState<number | '100%'>(defaultHeight)
  const [showBanner, setShowBanner] = useState(true)
  const { classes } = useStyles(
    {
      isFullScreen: modalHeight === '100%',
      showBanner,
    },
    {
      name: 'DrawerModal',
    },
  )

  useEffect(() => {
    if (!opened) {
      setModalHeight(defaultHeight)
      setShowBanner(true)
    }
    const listInput = ['INPUT', 'SELECT']
    const handleFocus = function () {
      const activeElement = document.activeElement
      if (listInput.includes(activeElement?.tagName || '')) {
        setModalHeight('100%')
      }
    }
    setTimeout(() => ref.current?.addEventListener('click', handleFocus), 1000)

    return () => {
      ref.current?.removeEventListener('click', handleFocus)
    }
  }, [opened])

  return (
    <Drawer.Root
      target={MANTINE_MODAL_TARGET}
      opened={opened}
      position="bottom"
      closeOnClickOutside
      onClose={close}
    >
      <Drawer.Overlay />
      <Drawer.Content
        className={classes.drawerContent}
        sx={{ height: modalHeight }}
        onScroll={() => setModalHeight('100%')}
      >
        <Drawer.Body className={classes.drawerBody}>
          <Button
            variant={'white'}
            className={classes.closeWithIconBtn}
            dataEventCategory={'Leadgen Pop Up'}
            dataEventAction={'Close Click'}
            dataEventLabel={currentUrl}
            rightIcon={<Close size={18} />}
            onClick={() => close()}
          />
          {showBanner && (
            <Box className={classes.topArea}>
              <AspectRatio ratio={375 / 250}>
                <img
                  src={banner.mobile}
                  className={classes.bannerImg}
                  alt="Đăng ký xem Livestream ngay!"
                  loading="lazy"
                />
              </AspectRatio>
              <Box
                className={classes.dragHandler}
                style={{
                  display: modalHeight === '100%' ? 'none' : 'block',
                }}
              >
                <Draggable
                  axis="y"
                  onDrag={(_v, data) => {
                    data.lastY < 0 &&
                      setModalHeight((modalHeight as number) - data.lastY)
                  }}
                  onStop={() => {
                    const windowHeight = window.innerHeight
                    setModalHeight(
                      (modalHeight as number) < windowHeight / 2
                        ? defaultHeight
                        : '100%',
                    )
                  }}
                >
                  <AspectRatio ratio={375 / 250} sx={{ width: '100%' }}>
                    <div
                      style={{
                        height: '100%',
                      }}
                    ></div>
                  </AspectRatio>
                </Draggable>
              </Box>
            </Box>
          )}
          <Box className={classes.formArea} ref={ref}>
            <LeadForm
              {...{
                isModal,
                classNames: {
                  root: classes.form,
                  // controlList: classes.formControlList,
                  // formFrame: classes.formFrame,
                },
                campaign: campaigns,
                thankYouMessage,
                isSkippable,
                onClose: (closeThankyou) => {
                  closeThankyou()
                  isModal && close()
                  // onCloseForm?.()
                },
              }}
              onShowThankyou={() => setShowBanner(false)}
            />
          </Box>
        </Drawer.Body>
      </Drawer.Content>
    </Drawer.Root>
  )
}
